export default __webpack_public_path__ + "static/media/Dr. Ramesh Raskar.2dcb9544.jpg";